export const globalStyle = {
  html: {
    scrollBehavior: "smooth",
    h: "100%",
    fontSize: "16pt",
  },
  body: {
    color: "black",
    h: "100%",
    maxWidth: "100vw",
  },
  "#root": {
    h: "100%",
  },
};
